module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Medium.e68e938a.otf";